import React from "react";
import { NumberChip, Tab } from "./PageTab.styles";
import type { PageTabProps } from "./PageTab.types";

/** A numbered page tab: a number chip and a name. The shown page carries aria-current="page". */
export const PageTab: React.FC<PageTabProps> = ({ label, number, isActive, onClick, onDoubleClick, title, className }) => (
  <Tab type="button" $isActive={isActive} aria-current={isActive ? "page" : undefined} onClick={onClick} onDoubleClick={onDoubleClick} title={title} className={className}>
    <NumberChip $isActive={isActive} aria-hidden>
      {number}
    </NumberChip>
    {label}
  </Tab>
);

export default PageTab;
